import { Component, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { Router } from '@angular/router';
import { Dashboard } from 'src/app/model/dashboard.modals';
// import * as d3 from 'd3';
// import * as CalHeatMap from  'cal-heatmap' ;

// Import dependencies
// import * as moment from 'moment';
// import * as d3 from 'd3';
import { window } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})

export class DashboardComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewInit {
  dashboard = new Dashboard();
  currentYear = new Date().getFullYear();
  isYearDataAvailable = true;
  latestLoginList: any;
  latestSignUps: any;
  isTenant: boolean = false;
  isLoading: boolean;
  calender: any;

  ngAfterViewInit() {
    // this.loadCalendarData();
  }
  ngOnDestroy() {
  }
  constructor(private dashboardService: DashboardService, public router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }
  data: Array<object> = [];
  private org_id = null;

  ngOnInit() {


    this.org_id = localStorage.getItem('org_id');
    this.isTenant = localStorage.getItem('type') == '1' ? true : false;
    if (this.isTenant) {
      this.loadDashboardData();

    }

  }

  applicationModel: any = [];
  color = '#EC2D40';
  print(val: object): void {
    alert(val);
  }

  handleOnChange(val: object): void {
    let startYear = new Date(val["start"]).getFullYear();
    let endYear = new Date(val["end"]).getFullYear();
    if (this.currentYear != endYear && (endYear - startYear) == 0) {
      this.currentYear = endYear;
      // this.loadCalendarData(this.currentYear);
    }
    $("rect").css("rx", 0);
    $("rect").css("ry", 0);
    $('rect').on('mouseover', function () {
      console.log('Rect', $('.header').parent());
      $('.header').parent().css({ "background-color": "black", "color": "white" })
      $('.header strong').remove();
      debugger;
      let tooltip = Array.from($('.header').parent().find('div'));
      tooltip.splice(tooltip.findIndex(x => x.innerText == '0 seconds'), 1);
      tooltip.splice(tooltip.findIndex(x => x.className == 'header'), 1);
      //   for(let i=2;i<tooltip.length;i++){
      //     let headDiv=tooltip[i];
      //    let name= $($(headDiv).find('span')[0]).find('strong').text().split('#');
      //    $(headDiv).find('strong').text(name[0]);
      //    let date=new Date(name[2]);
      //    if(date.toString()!=="Invalid Date")
      //    $(headDiv).find('span:eq(1)').text(moment(date).format("hh:mm A"));
      // }
      // $('.header').parent().find('div').children().remove();
      $('.header').parent().find('div').slice(3).remove(); //remove all divs except first three
      if ($('.header').parent().find('div')[2] == undefined)
        $('.header').parent().append('<div></div>');
      $('.header').parent().find('div')[2].innerHTML = '<div><i class="fa fa fa-calculator m-r-xxs"></i>Total logins: ' + (Number(tooltip.length) - 1) + '</div>';
      $('.header').parent().find('span:contains("0 seconds")').remove();
    });
    if (!this.isYearDataAvailable) {
      //$('rect').css('background-color','#fde4e6');

      $('rect').attr('fill', '#fde4e6');
    }

  }

  loadDashboardData() {
    this.isLoading = true
    this.dashboardService.getLoginSignUpData(this.org_id).subscribe((res) => {
      if (!res['error']) {
        this.dashboard = res["data"] as Dashboard;
        this.isLoading = false
      } else {
        this.isLoading = false
        alert(res["errorMessage"]);
      }

    })
  }

  addRoute() {
    this.router.navigate(['add-application'], { queryParams: { opt: 'add' } });
  }



}

